import type { IProductItemConstructorParams } from "@services/sdk/interfaces";
import { map } from "ramda";

import type AddonProduct from "@services/sdk/models/addon-product";
import ProductInfo from "./product-info";

class ProductItem {
	static ConstructList(
		arrParams: Array<IProductItemConstructorParams>,
	): Array<ProductItem> {
		return map(ProductItem.Construct)(arrParams);
	}

	static Construct(params: IProductItemConstructorParams): ProductItem {
		return new ProductItem(params);
	}

	static ConstructFromAddon(addon: AddonProduct): ProductItem {
		return new ProductItem({
			iconRef: addon.iconRef,
			info: addon.info,
			label: addon.name,
			order: "",
		});
	}

	responseData: IProductItemConstructorParams;

	constructor(params: IProductItemConstructorParams) {
		this.responseData = params;
	}

	get order(): number {
		return Number.parseInt(this.responseData.order, 10);
	}

	get iconRef(): string {
		if (!this.responseData.iconRef) {
			return "leaf";
		}

		return this.responseData.iconRef;
	}

	get label(): string {
		return this.responseData.label;
	}

	get hasInfo(): boolean {
		return !!this.responseData.info;
	}

	get info(): ProductInfo | null {
		if (!this.responseData.info) {
			return null;
		}

		return ProductInfo.Construct(this.responseData.info);
	}
}

export default ProductItem;
